import axios from "axios";
import { userSocialLinkApi } from '../_constants/api.constant'
import {  getSelfToken } from '../../_helpers/auth/secureToken'
export async function getSocial(id) {
    const response = await axios.get(
        userSocialLinkApi.GET+'?search='+id, 
        //+"/"+id,
        {
            headers: {
                Authorization: 'Token ' + getSelfToken(),
            },
        }
    ).then(function (response) {
        return response;
    }).catch(function (error) {
        // handle error
        console.log(error);
        console.log(error.response);
        return error.response;
    });
    return response;
}